﻿import { ISwapManager } from './swap-manager';

export interface ISwapTracker {
    clusterId: number;
    chainId: number;
    clusterNumber: number;
    positionNumber: number;
    donorId: number;
    donorAlias: string;
    donorCenterId: number;
    donorCenter: string;
    donorCenterTimezone: string;
    rdnCenterId: number;
    rdnCenterAlias: string;
    rdnCenterTimezone: string;
    recipientId: number;
    recipientAlias: string;
    recipientCenter: string;
    recipientCenterId: number;
    clusterStatus: string;
    surgeryDate: string;
    shipBackDate: string;
    offerAcceptance: number;
    logisticsCallScheduled: number;
    sxmRecorded: number;
    donorClearance: number;
    serologiesReturned: number;
    serologiesRecorded: number;
    finalXmComplete: number;
    finalXmUploadDateTime: string;
    finalXmDeadlineDateTime: string;
    kickoffCall: number;
    challengingLogistics: number;
    swapManager: ISwapManager;
}
